import React from 'react';

import { Button, Modal, Icon, Grid } from '@mairistem/composants';

interface ClotureConfirmationModalProps {
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
  isClotured: boolean;
}

const ClotureConfirmationModal = (props: ClotureConfirmationModalProps) => {
  const { onClose, onConfirm, isClotured, loading } = props;

  return (
    <Modal
      open
      size="small"
      closeOnDimmerClick
      closeOnDocumentClick
      closeOnEscape
      onClose={onClose}
      data-testid="modal-confirmation-cloture"
    >
      <Modal.Header>
        {isClotured ? 'Déclôture' : 'Clôture'} du trimestre
      </Modal.Header>
      <Modal.Content>
        <Grid>
          <Grid.Row style={{ alignItems: 'center' }}>
            <Grid.Column width={3}>
              <Icon size="massive" name="warning sign" />
            </Grid.Column>
            <Grid.Column width={1} />

            <Grid.Column width={12}>
              <div>
                Êtes-vous sûr de vouloir{' '}
                {isClotured ? 'déclôturer' : 'clôturer'} le trimestre ?
                <br />
                {!isClotured && (
                  <>
                    La clôture du trimestre implique la création du prochain.
                    <br />
                    <br />
                    <b>Attention :</b> Il sera impossible d&apos;enregistrer des
                    recensés sur ce trimestre après la clôture.
                  </>
                )}
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="modal-cancel-confirm-cloture"
          basic
          size="tiny"
          icon="cancel"
          content="Annuler"
          onClick={onClose}
          disabled={loading}
          loading={loading}
        />
        <Button
          data-testid="modal-confirm-cloture"
          positive
          icon="check"
          content="Confirmer"
          onClick={onConfirm}
          disabled={loading}
          loading={loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ClotureConfirmationModal;
